import React from 'react'
import { MessageDescriptor } from 'react-intl'

import { isNil } from 'lodash-es'

type CompiledMessageDescriptor = Omit<MessageDescriptor, 'defaultMessage'> & {
  defaultMessage?: string | { value: string }[]
}

/**
 * Gets default message string from the message param, logic to retrieve string depends on type of message param
 *
 * Some messages that are typed as `MessageDescriptor` may actually already be compiled in ast format and so the `defaultMessage` is not a string but an array of objects with a `value` property.
 *
 * @param message message descriptor, string, or a React Node type message
 */
export const getStringFromMessage = (message: CompiledMessageDescriptor | string | React.ReactNode) => {
  if (isNil(message)) {
    return
  }

  let messageAsString: string | undefined
  if (React.isValidElement<CompiledMessageDescriptor>(message)) {
    const { defaultMessage } = message.props
    if (Array.isArray(defaultMessage) && defaultMessage.length > 0) {
      messageAsString = defaultMessage.map((part) => part.value).join('')
    }
  } else if (typeof message === 'string') {
    messageAsString = message
  } else {
    const { defaultMessage } = message as CompiledMessageDescriptor
    if (Array.isArray(defaultMessage) && defaultMessage.length > 0) {
      messageAsString = defaultMessage.map((part) => part.value).join('')
    } else if (typeof defaultMessage === 'string') {
      messageAsString = defaultMessage
    }
  }

  return messageAsString
}
